import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { useStoreState } from "easy-peasy";

function ErpData() {
  const erpHTML = useStoreState(state => state.selection.erpHTML);

  const currentFrequency = useStoreState(state => state.selection.designPoint.frequency);
  const fanFrequency = useStoreState(state => state.selection.fan.frequency);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const menuRef = useRef(null);

  if (!menuRef.current) {
    // Create once
    menuRef.current = document.getElementById("erp-data");
    menuRef.current.innerHTML = "";
  }

  const domElement = menuRef.current;

  if (erpHTML === "") {
    return <></>
  }

  const frequency_warning = fanFrequency !== currentFrequency ? `(${fanFrequency}Hz)` : "";

  return ReactDOM.createPortal(
    <div className="row">
      <div className="col-xs-12"><h2>ERP {frequency_warning}</h2></div>
      <div id="erp-table" className="col-xs-12" dangerouslySetInnerHTML={{ __html: erpHTML }} />
    </div>
    , domElement
  );
}

export default ErpData;
